<template>
  <div class="booking-container">
    <nav class="booking-nav">
      <router-link to="/booking" class="nav-link" active-class="active">
        รายการจอง
      </router-link>
      <router-link to="/booking/temp-payments" class="nav-link" active-class="active">
        การชำระเงินชั่วคราว
      </router-link>
      <router-link to="/booking/approve" class="nav-link" active-class="active">
        อนุมัติการชำระเงิน
      </router-link>
      <router-link to="/booking/config" class="nav-link" active-class="active">
        ตั้งค่าการจอง
      </router-link>
      <router-link to="/booking/trash" class="nav-link" active-class="active">
        ถังขยะ
      </router-link>
    </nav>

    <router-view v-if="$route.path !== '/booking'" />
    <div v-else class="booking-content">
      <div class="booking-type-indicator">
        <span class="type-label">ประเภทการจอง:</span>
        <select v-model="selectedType" class="type-select">
          <option value="hotel">โรงแรม</option>
          <option value="restaurant">ร้านอาหาร</option>
        </select>
      </div>

      <div class="calendar-container">
        <FullCalendar :options="calendarOptions" />
      </div>

      <div class="booking-form">
        <h3>จองใหม่</h3>
        <form @submit.prevent="submitBooking">
          <div class="form-group">
            <label>ประเภท:</label>
            <select v-model="newBooking.type" required>
              <option value="hotel">โรงแรม</option>
              <option value="restaurant">ร้านอาหาร</option>
            </select>
          </div>

          <div class="form-group">
            <label>โรงแรม/ร้านอาหาร:</label>
            <select v-model="newBooking.shopId" required>
              <option v-for="shop in filteredShops" :key="shop.id" :value="shop.id">
                {{ shop.name }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>วันที่:</label>
            <input type="date" v-model="newBooking.date" required>
          </div>

          <div class="form-group">
            <label>สลิปการชำระเงิน:</label>
            <input type="file" @change="handleFileUpload" accept="image/*" required>
          </div>

          <button type="submit" class="submit-btn">จอง</button>
        </form>
      </div>
    </div>

    <!-- Modal สำหรับดูรายละเอียดการจอง -->
    <div v-if="selectedBooking" class="modal-overlay" @click="selectedBooking = null">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>รายละเอียดการจอง</h3>
          <button class="close-btn" @click="selectedBooking = null">&times;</button>
        </div>
        <div class="modal-body">
          <p><strong>วันที่:</strong> {{ formatDate(selectedBooking.date) }}</p>
          <p><strong>ประเภท:</strong> {{ selectedBooking.type === 'hotel' ? 'โรงแรม' : 'ร้านอาหาร' }}</p>
          <p><strong>ห้อง/โต๊ะ:</strong> {{ selectedBooking.roomId || selectedBooking.tableId }}</p>
          <p><strong>เวลาเช็คอิน:</strong> {{ selectedBooking.checkInTime }}</p>
          <p><strong>เวลาเช็คเอาท์:</strong> {{ selectedBooking.checkOutTime }}</p>
          <p><strong>สถานะ:</strong> {{ selectedBooking.status }}</p>
          <p><strong>สลิปการชำระเงิน:</strong></p>
          <img :src="selectedBooking.paymentReceipt" alt="Payment Receipt" class="payment-receipt" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { collection, getDocs, query, addDoc, updateDoc, where } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db, doc, storage, getDoc, setDoc } from "../firebase";

export default {
  components: { FullCalendar },
  data() {
    return {
      userInfo: "User Name",
      userType: "User Type",
      shopId: "",
      shopType: "",
      type: "hotel",
      id: "",
      date: new Date().toISOString().split('T')[0],
      currentDate: new Date().toISOString().split('T')[0],
      selectedId: "",
      checkInTime: "",
      checkOutTime: "",
      timeSlot: "",
      available: {},
      availableCheckInSlots: [],
      availableCheckOutSlots: [],
      availableTimeSlots: [],
      paymentFile: null,
      paymentFileName: "",
      submitting: false,
      shops: [],
      filteredShops: [],
      bookings: [],
      selectedBooking: null,
      calendarOptions: {
        plugins: [dayGridPlugin],
        initialView: "dayGridMonth",
        events: [],
        eventClick: this.handleEventClick,
        eventTimeFormat: {
          hour: '2-digit',
          minute: '2-digit',
          meridiem: 'short'
        }
      },
      selectedType: "hotel",
      newBooking: {
        type: "hotel",
        shopId: "",
        date: "",
      },
    };
  },
  methods: {
    initializeFirebase() {
      this.auth = auth;
    },
    async checkAuthState() {
      onAuthStateChanged(auth, async (user) => {
        if (user) {
          this.userInfo = user.displayName;
          this.uid = user.uid;

          const idTokenResult = await user.getIdTokenResult(true);
          console.log("🛠️ User Role:", idTokenResult.claims.role || "Not Assigned");
          console.log("🛠️ Assigned Shop:", idTokenResult.claims.shopId || "None");

          console.log("Email:", user.email);
          console.log("Display Name:", user.displayName);
          console.log("UID:", user.uid);

          try {
            const userDocRef = doc(db, "users", user.email);
            const userDoc = await getDoc(userDocRef);

            if (userDoc.exists()) {
              console.log(`User ${user.email} exists. Retrieving shop data...`);
              const userData = userDoc.data();
              this.shopId = userData.shopId;

              const shopDocRef = doc(db, "shops", this.shopId);
              const shopDoc = await getDoc(shopDocRef);

              if (shopDoc.exists()) {
                const shopData = shopDoc.data();
                this.shopType = shopData.typeshop;
                this.type = this.shopType;
                this.id = this.shopId;
                
                this.filteredShops = [{
                  id: this.shopId,
                  name: shopData.name,
                  typeshop: shopData.typeshop,
                  ownerEmail: shopData.ownerEmail
                }];
                
                console.log(`Shop Name: ${shopData.name}`);
                console.log(`Shop Type: ${shopData.typeshop}`);
                console.log(`Owner Email: ${shopData.ownerEmail}`);
                
                if (this.shopType === 'hotel' && !shopData.hotelRooms) {
                  await updateDoc(shopDocRef, {
                    hotelRooms: ["roomA", "roomB", "roomC","roomD","roomE"]
                  });
                  console.log("Added default hotel rooms to shop data");
                  
                } else if (this.shopType === 'restaurant' && !shopData.restaurantTables) {
                  await updateDoc(shopDocRef, {
                    restaurantTables: ["table1", "table2", "table3", "table4", "table5"]
                  });
                  console.log("Added default restaurant tables to shop data");
                }
                
                await this.fetchApprovedBookings();
                await this.fetchAvailableBookings();
              }
            } else {
              console.log(`Creating new user entry for: ${user.email}`);
              const shopWaitDocRef = doc(db, "users_wait", user.email);
              await setDoc(shopWaitDocRef, {
                uid: user.uid,
                email: user.email,
                role: "user",
                shopId: "shop",
                status: "starter",
                createdBy: "web",
                createdAt: new Date(),
              }, { merge: true });
            }
          } catch (error) {
            console.error("Error fetching user/shop data:", error);
          }
        } else {  
          console.log("User not authenticated. Redirecting to login...");
          this.$router.push("/");
        }
      });
    },

    async fetchAvailableBookings() {
      if (!this.type || !this.id || !this.date) return;

      try {
        const response = await axios.get(
          `https://getavailablebookings-u32waniu4a-df.a.run.app?type=${this.type}&id=${this.id}&date=${this.date}`
        );
        this.available = response.data.available;
        console.log("📌 Updated available slots:", this.available);
        this.availableCheckInSlots = [];
        this.availableCheckOutSlots = [];
        this.availableTimeSlots = [];
        this.fetchApprovedBookings();
      } catch (error) {
        console.error("❌ Error fetching availability:", error);
      }
    },

    async fetchApprovedBookings() {
      try {
        let q;
        
        if (this.id) {
          q = query(
            collection(db, "bookings"),
            where(this.type === "hotel" ? "hotelId" : "restaurantId", "==", this.id)
          );
          console.log(`Fetching bookings for specific shop: ${this.id}`);
        } else if (this.shopId) {
          q = query(
            collection(db, "bookings"),
            where(this.shopType === "hotel" ? "hotelId" : "restaurantId", "==", this.shopId)
          );
          console.log(`Fetching bookings for user's assigned shop: ${this.shopId}`);
        } else {
          console.log("No shop ID specified, no bookings will be shown");
          this.bookings = [];
          this.calendarOptions.events = [];
          return;
        }

        const querySnapshot = await getDocs(q);
        this.bookings = querySnapshot.docs.map(doc => {
          return {
            id: doc.id,
            ...doc.data()
          };
        });
        
        const events = this.bookings.map((booking) => {
          const title = booking.isApproved ? `✓ ` : `⌛ `;
          return {
            id: booking.id,
            title: title + (booking.type === 'hotel' 
              ? `Room ${booking.roomId} - ${booking.checkInTime}` 
              : `Table ${booking.tableId} - ${booking.timeSlot}`),
            start: booking.date,
            allDay: false,
            backgroundColor: booking.isApproved ? '#4CAF50' : '#FFC107',
            textColor: booking.isApproved ? 'white' : 'black',
            borderColor: booking.isApproved ? '#45a049' : '#FF9800',
          };
        });

        console.log(`✅ Found ${events.length} bookings for calendar`);
        this.calendarOptions.events = events;
      } catch (error) {
        console.error("❌ Error fetching bookings:", error);
      }
    },

    updateAvailableSlots() {
      if (this.selectedId) {
        if (this.type === "hotel") {
          this.availableCheckInSlots = this.available[this.selectedId]?.checkInSlots || [];
          this.availableCheckOutSlots = this.available[this.selectedId]?.checkOutSlots || [];
        } else if (this.type === "restaurant") {
          this.availableTimeSlots = this.available[this.selectedId] || [];
        }
      }
    },

    handleFileUpload(event) {
      this.paymentFile = event.target.files[0];
      if (this.paymentFile) {
        this.paymentFileName = this.paymentFile.name;
      }
    },

    async submitBooking() {
      if (
        !this.selectedId ||
        !this.date ||
        (this.type === "hotel" && (!this.checkInTime || !this.checkOutTime)) ||
        (this.type === "restaurant" && !this.timeSlot)
      ) {
        alert("❌ Please complete all fields!");
        return;
      }

      if (!this.paymentFile) {
        alert("❌ Please upload a payment receipt!");
        return;
      }

      this.submitting = true;
      try {
        const storageRef = ref(storage, `payments/${Date.now()}_${this.paymentFile.name}`);
        await uploadBytes(storageRef, this.paymentFile);
        const imageUrl = await getDownloadURL(storageRef);

        await addDoc(collection(db, "bookings"), {
          type: this.type,
          [this.type === "hotel" ? "hotelId" : "restaurantId"]: this.id,
          [this.type === "hotel" ? "roomId" : "tableId"]: this.selectedId,
          date: this.date,
          checkInTime: this.type === "hotel" ? this.checkInTime : null,
          checkOutTime: this.type === "hotel" ? this.checkOutTime : null,
          timeSlot: this.type === "restaurant" ? this.timeSlot : null,
          paymentReceipt: imageUrl,
          isApproved: false,
        });

        alert("✅ Booking submitted! Waiting for admin approval.");
        this.resetForm();
        this.fetchApprovedBookings();
      } catch (error) {
        console.error("❌ Booking submission failed:", error);
        alert("❌ Failed to submit booking.");
      }
      this.submitting = false;
    },

    resetForm() {
      this.selectedId = "";
      this.date = "";
      this.checkInTime = "";
      this.checkOutTime = "";
      this.timeSlot = "";
      this.paymentFile = null;
      this.paymentFileName = "";
    },

    handleDateChange() {
      if (this.date <= this.currentDate) {
        alert("❌ Cannot select a past date!");
        this.date = this.currentDate;
        return;
      }
      this.fetchAvailableBookings();
    },

    handleEventClick(info) {
      const bookingId = info.event.id;
      const booking = this.bookings.find(booking => booking.id === bookingId);
      if (booking) {
        this.selectedBooking = booking;
        console.log("Selected booking:", booking);
      }
    },
  },
  
  async mounted() {
    await this.initializeFirebase();
    await this.checkAuthState();
    if (!this.shopId) {
      await this.fetchApprovedBookings();
    }
  },
};
</script>

<style scoped>
.booking-container {
  padding: 20px;
}

.booking-nav {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 8px;
}

.nav-link {
  padding: 8px 16px;
  text-decoration: none;
  color: #495057;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.nav-link:hover {
  background: #e9ecef;
}

.nav-link.router-link-active {
  background: #007bff;
  color: white;
}

.booking-content {
  margin-top: 20px;
}

.booking-type-indicator {
  background-color: #f0f8ff;
  padding: 8px 12px;
  border-radius: 4px;
  margin-bottom: 20px;
  border-left: 4px solid #4a90e2;
}

.calendar-container {
  margin-bottom: 30px;
}

.booking-details {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  margin: 20px 0;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

.details-content {
  text-align: left;
}

.payment-image {
  margin-top: 15px;
}

.payment-image img {
  max-width: 100%;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-top: 10px;
}

.close-btn {
  background-color: #f44336;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 15px;
}

.close-btn:hover {
  background-color: #d32f2f;
}

.booking-form {
  max-width: 500px;
  margin: 0 auto;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.form-group select, 
.form-group input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.file-selected {
  margin-top: 5px;
  color: #4a90e2;
}

.submit-btn {
  background-color: #4CAF50;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  width: 100%;
  margin-top: 20px;
}

.submit-btn:hover {
  background-color: #45a049;
}

.submit-btn:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  animation: modalFadeIn 0.3s ease;
}

@keyframes modalFadeIn {
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  background-color: #f8f9fa;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.modal-header h3 {
  margin: 0;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  line-height: 1;
}

.close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
  text-align: left;
}

.payment-receipt {
  max-width: 100%;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-top: 10px;
}
</style>
